import React from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

interface PaginateParams {
  page: number;
  total: number;
  itensPerPage: number;
  onPaginateChange: (selectedItem: { selected: number }) => void;
}

export const Paginate = (params: PaginateParams) => {
  const { page, total, itensPerPage, onPaginateChange } = params;
  const pageCount = total / itensPerPage;

  return (
    <Styled>
      <ReactPaginate
        previousLabel={'anterior'}
        nextLabel={'próximo'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={pageCount}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        forcePage={page}
        onPageChange={onPaginateChange}
        containerClassName={'pagination'}
        activeClassName={'active'}
      />
    </Styled>
  );
};

const Styled = styled.div`
  ul {
    text-align: center;
    padding: 0;

    li {
      display: inline-block;
      padding: 0 0.5em;
      cursor: pointer;
    }

    .active {
      font-size: 1.1em;
      font-weight: bold;
      text-decoration: underline;
    }
  }
`;
